import { Component, Inject, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalShellComponent, ModalShellConfig } from '@shared/components/modal-shell/modal-shell.component';

export interface DeleteConfirmDialogData {
  title: string;
  message?: string;
  content?: string; // HTML personalizado para reemplazar el contenido por defecto
  template?: TemplateRef<any>; // Template + contexto como alternativa más elegante
  templateContext?: any;
  confirmButtonText?: string;
  cancelButtonText?: string;
  requiresReason?: boolean;
}

@Component({
  selector: 'app-delete-confirm-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    ModalShellComponent
  ],
  templateUrl: './delete-confirm-dialog.component.html',
  styleUrls: ['./delete-confirm-dialog.component.scss'],
  host: { 'class': 'delete-confirm-dialog-host' }
})
export class DeleteConfirmDialogComponent {
  readonly modalConfig: ModalShellConfig;
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DeleteConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteConfirmDialogData,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer
  ) {
    this.modalConfig = { title: data.title, size: 'sm', layout: 'confirm', tone: 'danger' };
    this.form = this.fb.group({
      deletionReason: ['', data.requiresReason ? [Validators.required, Validators.minLength(5)] : []]
    });
  }

  /**
   * Retorna el contenido del diálogo (personalizado o vacío)
   * Si hay 'content' lo retorna directamente
   * Si hay 'message' lo retorna (para compatibilidad)
   * Si no hay nada, retorna vacío
   */
  getFormattedMessage(): SafeHtml {
    if (this.data.content) {
      return this.sanitizer.bypassSecurityTrustHtml(this.data.content);
    }

    if (this.data.message) {
      return this.sanitizer.bypassSecurityTrustHtml(this.data.message);
    }

    return this.sanitizer.bypassSecurityTrustHtml('');
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    if (this.data.requiresReason) {
      if (this.form.invalid) {
        this.form.markAllAsTouched();
        return;
      }

      this.dialogRef.close({
        confirmed: true,
        deletionReason: this.form.get('deletionReason')?.value
      });
    } else {
      this.dialogRef.close(true);
    }
  }
}
